/**
 * DateRange field — przechowuje dwie daty: start i end.
 *
 * DDL (F12.B multi-column): dwie fizyczne kolumny `<slug>__start DATE` + `<slug>__end DATE`.
 * W formularzu wartość = { start: string | null, end: string | null }.
 * API records zwraca/przyjmuje płaski obiekt: { "<slug>__start": "2026-01-01", "<slug>__end": "2026-12-31" }.
 * FieldRegistry renderInput/renderCell operuje na zgrupowanym `{ start, end }`.
 */

import { FieldRegistry } from '../FieldRegistry';

interface DateRangeValue {
  start: string | null;
  end: string | null;
}

FieldRegistry.register({
  type: 'daterange',
  renderInput: ({ value, onChange }) => {
    const val = (value as DateRangeValue | null) ?? { start: null, end: null };
    return (
      <div className="flex items-center gap-2">
        <input
          type="date"
          value={val.start ?? ''}
          onChange={(e) => onChange({ ...val, start: e.target.value || null })}
          className="flex-1 rounded-md border border-border-primary bg-bg-primary px-2 py-1.5 text-sm text-text-primary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
          placeholder="Od"
        />
        <span className="text-text-muted text-sm">–</span>
        <input
          type="date"
          value={val.end ?? ''}
          min={val.start ?? undefined}
          onChange={(e) => onChange({ ...val, end: e.target.value || null })}
          className="flex-1 rounded-md border border-border-primary bg-bg-primary px-2 py-1.5 text-sm text-text-primary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
          placeholder="Do"
        />
      </div>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    const v = value as DateRangeValue;
    if (!v.start && !v.end) return '—';
    return `${v.start ?? '?'} – ${v.end ?? '?'}`;
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    const v = value as DateRangeValue;
    if (field.isRequired && (!v.start || !v.end)) return 'Podaj obie daty';
    if (v.start && v.end && v.start > v.end) return 'Data końcowa musi być >= startowej';
    return null;
  },
  defaultValue: { start: null, end: null },
});
